
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HandleError, HttpErrorHandlerService } from '../../http-error-handler.service';
import { OrganiserDetails } from 'src/app/model/Sale/pos/organiser-details';
import { CartInitialDto } from 'src/app/model/Sale/pos/cart-initial-dto';
import { catchError } from 'rxjs/operators';
import { Cart } from 'src/app/model/Sale/cart';
import { OrganiserBillingDto } from 'src/app/model/Sale/OrganiserBillingDto/organiser-billing-dto';
import { GstSaleInvCumBos } from 'src/app/model/Sale/GstSaleInvCumBos/gst-sale-inv-cum-bos';
import { PrintTokenMaster } from 'src/app/model/Sale/pos/PrintToken/print-token';
import { ProductColors } from 'src/app/model/Master/Others/product-color';
import { ProductComposition } from 'src/app/model/Master/Composition/product-composition';
import { Storage } from 'src/app/model/Master/Storage/storage';
import { Brand } from 'src/app/model/Master/Brand/brand';
import { Designation } from 'src/app/model/Master/Designation/designation';
import { ProductShape } from 'src/app/model/Master/Others/product-shape';
import { AdvanceSearchDTO } from 'src/app/model/Sale/AdvanceSearchDTO/advance-search-dto';
import { ProductDetails } from 'src/app/model/FacilityManager/product-details';
import { Customer } from 'src/app/model/Sale/pos/customer';
import { CustomerDeliveryDetails } from 'src/app/model/Master/CustomerDeliveryDetails/customer-delivery-details';
import { PromotionMaster } from 'src/app/model/WebOrderSetup/promotionmaster';
import { ServiceMan } from 'src/app/model/Master/ServiceMan/service-man';
import { RequestView } from 'src/app/model/OrderManagement/OrderStock/RewMaterials/RequestView/request-view';
import { LocalStorageService } from 'src/app/common/LocalStorageService';
import { SummaryReport } from 'src/app/model/summary-report';
import { DatePipe } from '@angular/common';
import { FestivalCouponRedemption } from 'src/app/model/Sale/pos/festival-coupon-redemption';

@Injectable({
  providedIn: 'root'
})
export class PosService {
  getOrderDetailsWithTerms(url: string, orderno: any, locId: any) {
    return this.httpClient.get(url + '/' + orderno + '/' + locId);
  }
  viewFileInBrowser
    (url: string, filename: string) {
    return this.httpClient.get(url + '/' + filename);
  }
  getMakeToOrderByLocIDAndMTONo(url: string, invNo: string, locId: number) {
    return this.httpClient.get(url + '/' + invNo + '/' + locId);
  }
  getCashRegisterDataWithTermsByInvNoAndLoc(url: string, invNo: string, locId: number) {
    return this.httpClient.get(url + '/' + invNo + '/' + locId);
  }

  statusToUpdateOrgDtls: string = null;

  getStatusToUpdate() {
    return this.statusToUpdateOrgDtls;
  }

  setStatusToUpdate(status) {
    this.statusToUpdateOrgDtls = status;
    this.localStorageService.set('status', status);
  }

  //Verify mobile No. 
  sendWhatsAppOptInByMobileNo(url: string, companyCode: number, mobileNo: string) {
    return this.httpClient.get(url + "/" + companyCode + "/" + mobileNo, {
      responseType: "json",
    });
  }

  private encryptedOtp: string = '';

  sendWhatsAppOTPByMobileNo(url: string, companyCode: number, mobileNo: string, otp: string) {
    this.encryptFun(otp);
    return this.httpClient.get(url + "/" + companyCode + "/" + mobileNo + "/" + this.encryptedOtp, {
      responseType: "json",
    });
  }

  encryptFun(data) {
    if (data.length > 9 || data.length < 5)
      return;
    var sum = 0;
    var newData = "";
    var newDataFinal = "";
    var sumz = "";
    const date = new Date();
    const day = this.datePipe.transform(date, 'dd');
    let ascV = 0;
    for (let i = 0; i < data.length; i++) {

      switch (Number(data.charAt(i))) {
        case 0: ascV = 59; break;
        case 1: ascV = 62; break;
        case 2: ascV = 35; break;
        case 3: ascV = 78; break;
        case 4: ascV = 67; break;
        case 5: ascV = 71; break;
        case 6: ascV = 46; break;
        case 7: ascV = 29; break;
        case 8: ascV = 53; break;
        default: ascV = 92; break;
      }
      sum += ascV;
      newData += ascV.toString();
    }
    sum += Number(day);
    for (let i = 0; i < newData.length; i++) {
      newDataFinal += newData.toString().charAt(i);
      if (i == 2)
        newDataFinal += sum.toString().charAt(0);
      if (i == 5)
        newDataFinal += sum.toString().charAt(1);
      if (i == 8)
        newDataFinal += sum.toString().charAt(2);
    }

    newDataFinal = sum.toString() + newDataFinal + data.length.toString();
    this.encryptedOtp = newDataFinal;

    // alert(sum+"==="+data+"==="+newData+"==="+newDataFinal)
  }


  getPrintTokenRefNo(url: string, locationCode: number) {
    return this.httpClient.get<any>(url + '/' + locationCode)
  }

  gstSaleInvCumBos: GstSaleInvCumBos = new GstSaleInvCumBos();
  cartData: Cart = new Cart();

  updateOrgDetailsStatusToOpen(url: string, orgDetailsId: number, status: string) {
    return this.httpClient.patch(url + '/' + orgDetailsId + '/' + status, null);
  }

  getOrgDetailsStausByIdAndLocId(url: string, orgDetailsId: number, locId: number) {
    return this.httpClient.get<any>(url + '/' + orgDetailsId + '/' + locId);
  }

  getOrgDetailsStausById(url: string, orgDetailsId: number) {
    return this.httpClient.get<any>(url + '/' + orgDetailsId);
  }

  getCompanyRegistrationTypeByLocId(url: string, locId: number) {
    return this.httpClient.get(url + '/' + locId);
  }

  getCartNoByLoc(url: string, locId: number) {
    return this.httpClient.get<any>(url + '/' + locId)
  }

  getPromotionByRefNo(url: string, refNo: number) {
    return this.httpClient.get<PromotionMaster>(url + refNo);
  }

  setDetail(key: string, object: any) {
    if (key == 'InvoiceCumBOSData') {
      this.gstSaleInvCumBos = object;
    }
    if (key == 'CartData') {
      this.cartData = object;
    }
  }
  getDetail() {
    return { gstSaleInvCumBos: this.gstSaleInvCumBos, cart: this.cartData };
  }


  createPDF(readPdfApi: string, location: string, invoiceNo: string, module: string, userName): any {

    if (module == 'Credit Note')
      return this.httpClient.get<any>(readPdfApi + '/' + location + '/' + invoiceNo + '/' + userName, { responseType: 'arraybuffer' as 'json' });
    else
      return this.httpClient.get<any>(readPdfApi + '/' + location + '/' + invoiceNo + '/' + module, { responseType: 'arraybuffer' as 'json' });
  }

  createReportPDF(url: string, summaryReport: SummaryReport): any {
    return this.httpClient.post<any>(url, summaryReport, { responseType: 'arraybuffer' as 'json' });
  }


  createProductSummaryReport(url: string, requestView: RequestView): any {

    return this.httpClient.post<any>(url, requestView, { responseType: 'arraybuffer' as 'json' });

  }

  createPrintTokenPDF(readPdfApi: string, location: string, invoiceNo: string, module: string, printToken: any): any {
    return this.httpClient.post<any>(readPdfApi + '/' + location + '/' + invoiceNo + '/' + module, printToken, { responseType: 'arraybuffer' as 'json' });
  }

  handleError: HandleError;
  cashRegisterData: OrganiserDetails = new OrganiserDetails();
  // printedTokens: PrintTokenDetails = new PrintTokenDetails();

  constructor(
    private httpClient: HttpClient,
    httpErrorHandle: HttpErrorHandlerService,
    private localStorageService: LocalStorageService,
    private datePipe: DatePipe
  ) {
    this.handleError = httpErrorHandle.createHandleError('PosService');
  }

  //adv search start

  getproductComposition(url: string, word: string) {
    return this.httpClient.get<ProductComposition[]>(url + '/' + word);
  }
  getstorages(url: string) {
    return this.httpClient.get<Storage[]>(url);
  }
  getproductColor(url: string) {
    return this.httpClient.get<ProductColors[]>(url);
  }
  getBrand(url: string, word: string) {
    return this.httpClient.get<Brand[]>(url + '/' + word);
  }
  getDesignation(url: string) {
    return this.httpClient.get<Designation[]>(url);
  }
  getProductShape(url: string) {
    return this.httpClient.get<ProductShape[]>(url);
  }
  getMinMaxPrice(url: string) {
    return this.httpClient.get<any>(url);
  }
  searchProductsByObj(url: string, obj: AdvanceSearchDTO) {
    return this.httpClient.post(url, obj);
  }

  // adv search end


  getRefundUpiPaymentSubscription(url: string, merchantTranId: string, locId: number) {
    // let params = new HttpParams();
    // params = params.append('locId', "" + locId);
    // params = params.append('merchantTranId', "" + merchantTranId);

    // return this.httpClient.get<OrganiserBillingDto>(url + "?" + params)

    return this.httpClient.get<any>(url + '/' + merchantTranId + '/' + locId)
  }
  // getGstSaleInvCumBosInvNo(url: string, locId: number) {
  //   return this.httpClient.get<string>(url + '/' + locId);
  // }

  companyWiseSetup(url: string, companyCode: number) {
    return this.httpClient.get<any>(url + '/' + companyCode);
  }
  insertPrintToken(url: string, printTokens: PrintTokenMaster) {
    return this.httpClient.post(url, printTokens);
  }
  getPrintTokenDetails(url: string, refNo: number) {
    return this.httpClient.get<PrintTokenMaster>(url + '/' + refNo);
  }
  cashRegProcess(url: string, posData: Cart) {
    return this.httpClient.post(url, posData);
  }
  GstSaleInvCumBosInsert(url: string, gstSaleInvCumBos: GstSaleInvCumBos) {
    return this.httpClient.post(url, gstSaleInvCumBos);
  }
  GstSaleInvCumBosByCartNo(url: string, cartNo: string) {
    return this.httpClient.get<GstSaleInvCumBos>(url + "/" + cartNo);
  }
  updateInvStatus(url: string, invoiceNo: string, status: string, productDetails: ProductDetails[]) {
    return this.httpClient.post(url + "/" + invoiceNo + "/" + status, productDetails);
  }
  getServiceManByLocation(url: string, locId: number) {
    return this.httpClient.get<ServiceMan[]>(url + "/" + locId)
  }
  getRiders(url: string) {
    return this.httpClient.get<any>(url)
  }
  getPrintersData(url: string) {
    return this.httpClient.get<any>(url)
  }
  cancelOrgDetailsById(url: string, orgId: number) {
    return this.httpClient.get<any>(url + '/' + orgId)
    // .pipe(
    //   catchError(this.handleError('cancelOrgDetailsById()', []))
    // );
  }

  getBillingDetails(url: string, organiserCode: number, status: string) {
    let params = new HttpParams();
    params = params.append('organiserCode', "" + organiserCode);
    params = params.append('status', "" + status);

    return this.httpClient.get<OrganiserBillingDto>(url + "?", { params: params })
  }
  parkBill(url: string, req: Cart) {
    return this.httpClient.post(url, req)
  }

  getPosInitialData(url: string, locationCode: number): Observable<any> {
    return this.httpClient.get<any>(url + locationCode);
  }

  setOption(event: Event, organiserCode: number, refNo: number, organiserCurrentStatus: string, organiserDetailsName: string, walkInOrDelivery: boolean) {
    this.cashRegisterData.organiserClassCode = organiserCode;
    this.cashRegisterData.refNo = refNo;
    this.cashRegisterData.organiserCurrentStatus = organiserCurrentStatus;
    this.cashRegisterData.organiserDetailsName = organiserDetailsName;
    this.cashRegisterData.walkInOrDelivery = walkInOrDelivery;

    // Save data to Local Storage
    if (organiserCode)
      this.localStorageService.set('organiserClassCode', organiserCode.toString());
    else
      this.localStorageService.set('organiserClassCode', null);

    if (refNo)
      this.localStorageService.set('refNo', refNo.toString());
    else
      this.localStorageService.set('refNo', null);

    this.localStorageService.set('organiserCurrentStatus', organiserCurrentStatus);
    this.localStorageService.set('organiserDetailsName', organiserDetailsName);
  }
  getOption() {
    return this.cashRegisterData;
  }

  getCartData(url: string, locId: number, status: string, orgDetailsId: number) {
    let params = new HttpParams();
    params = params.append('locId', "" + locId);
    params = params.append('status', "" + status);
    params = params.append('orgDetailsId', "" + orgDetailsId);
    return this.httpClient.get<CartInitialDto>(url,
      { params: params })
  }

  getPromotionsByRefNos(url: string, offerIds: string[]) {
    if (offerIds.length == 0) {
      return <any>[];
    }
    return this.httpClient.get<any>(url + '/' + offerIds);
  }

  getProductSubgroup(url: string, productGroupCode: number) {
    return this.httpClient.get<any>(url + '/' + productGroupCode)
    // .pipe(
    //   catchError(this.handleError('getProductSubgroup()', []))
    // );
  }

  getProductsBySubGroupCode(url: string, productSubGroupCode: number, locationId: number) {
    return this.httpClient.get<any>(url + productSubGroupCode + '/' + locationId)
    // .pipe(
    //   catchError(this.handleError('getProductsBySubGroupCode()', []))
    // );
  }
  getProductsByProdcuctId(url: string, productId: number) {
    return this.httpClient.get<any>(url + '/' + productId);
  }
  getProductByIdForPosScan(url: string, locId: number, productId: number) {
    return this.httpClient.get<any>(url + '/' + locId + '/' + productId);
  }
  getProductSearch(url: string, locId: number, word: string) {
    return this.httpClient.get<any>(url + locId + '/' + word)
    // .pipe(
    //   catchError(this.handleError('getProductSearch()', []))
    // );
  }
  getCustomerSearch(url: string, mobileNo: string) {
    return this.httpClient.get<any>(url + '/' + mobileNo)
    // .pipe(
    //   catchError(this.handleError('getCustomerSearch()', []))
    // );
  }
  getCustomerClassList(url: string) {
    return this.httpClient.get<any>(url);
  }
  getCustomerInitialData(url: string, locId: number) {
    return this.httpClient.get<any>(url + "/" + locId);
  }
  getStatesList(url: string, countryCode: number) {
    return this.httpClient.get<any>(url + '/' + countryCode)
    // .pipe(
    //   catchError(this.handleError('getStatesList()', []))
    // );
  }
  getDistrictsByStateCode(url: string, stateCode: number) {
    return this.httpClient.get<any>(url + '/' + stateCode)
    // .pipe(
    //   catchError(this.handleError('getDistrictsByStateCode()', []))
    // );
  }
  insertCustomer(url: string, obj: Customer): Observable<any> {
    return this.httpClient.post<string>(url, obj)
    // .pipe(
    //   catchError(this.handleError('insertCustomer', 'I am an error')
    //   ));
  }
  insertCustomerDeliveryDetails(url: string, customerDeliveryDetails: CustomerDeliveryDetails) {
    return this.httpClient.post(url, customerDeliveryDetails);
  }
  getCustomerDeliveryDetailsByCustomerCode(url: string, customerCode: string) {
    return this.httpClient.get(url + "/" + customerCode);
  }
  deleteCustomerDeliveryDetailsById(url: string, refNo: number) {
    return this.httpClient.delete(url + "/" + refNo);
  }




  createPdf(url: string, locCode: number, invNo: string, module): any {
    return this.httpClient.get(url + '/' + locCode + '/' + invNo + '/' + module)
      .pipe(
        catchError(this.handleError('createPdf()', []))
      );
  }

  getAllStates(url: string) {
    return this.httpClient.get<any>(url)
    // .pipe(
    //   catchError(this.handleError('getStatesList()', []))
    // );
  }

  getCurrentOffersByLocId(url: string, locId: number) {
    return this.httpClient.get(url + "/" + locId);
  }

  getPdfWhatsapp(url: string) {
    return this.httpClient.get<any>(url, { responseType: 'arraybuffer' as 'json' });

  }

  getRedeemAvailableProductsCoupon(url: string, couponCode: string) {
    return this.httpClient.get(url + '/' + couponCode);
  }

  insertFestivalCouponRedemptionDetails(url: string, festivalCouponRedemption: FestivalCouponRedemption) {
    return this.httpClient.post(url, festivalCouponRedemption);
  }

  getRedeemedCouponsByLocation(url: string, req: RequestView) {
    return this.httpClient.post(url, req);
  }

  cancelCouponRedemption(url: string, refNo: number) {
    return this.httpClient.delete(url + '/' + refNo);
  }
  getDiscountDetailsByCode(url: string, discountCode: string, locationCode: number) {
    return this.httpClient.get<any>(url + '/' + discountCode + '/' + locationCode);
  }

  createReceiptVoucherPDF(url: string, voucherNo: any) {
    return this.httpClient.get<any[]>(url + '/' + voucherNo);  // ✅ JSON
  }

  generateKot(apiUrl: string, orderId: any) {
    return this.httpClient.get(apiUrl+ '/' + orderId, {
      responseType: 'blob'   // ✅ VERY IMPORTANT
    });
  }
}